import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from './shared/Button';
import Input from './shared/Input';
import Select from './shared/Select';
import './Contact.css';

const Contact = () => {
  const [formStatus, setFormStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus('');

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://formspree.io/f/xeorklzj', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      setFormStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <Link to="/play" className="back-link">
          ← Back to Game
        </Link>

        <h1 className="contact-title">Contact / Bitch / Whine</h1>
        <p className="contact-subtitle">
          Got a bug? Feature request? Just want to complain about that one card? We're all ears.
          (Well, metaphorically. We don't actually have ears. We're a website.)
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          {/* Honeypot field for spam prevention */}
          <input type="text" name="_gotcha" style={{ display: 'none' }} />

          <div className="form-group">
            <label htmlFor="name">Name (Optional)</label>
            <Input
              type="text"
              id="name"
              name="name"
              placeholder="Anonymous Complainer"
              ariaLabel="Your name (optional)"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <Input
              type="email"
              id="email"
              name="email"
              placeholder="your.email@example.com"
              required
              helperText="So we can actually respond to you"
              ariaLabel="Your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message-type">What's This About? *</label>
            <Select
              id="message-type"
              name="message-type"
              required
              placeholder="Select one..."
              options={[
                { value: 'bug', label: "🐛 Bug Report (Something's Broken)" },
                { value: 'feature', label: '💡 Feature Request (I Have Ideas)' },
                { value: 'feedback', label: '💭 General Feedback (Thoughts/Opinions)' },
                { value: 'complaint', label: '😤 Complaint (Let Me Vent)' },
                { value: 'question', label: '❓ Question (Help Me Understand)' },
                { value: 'other', label: '🤷 Other (None of the Above)' },
              ]}
              ariaLabel="Select message type"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message *</label>
            <textarea
              id="message"
              name="message"
              rows="8"
              placeholder="Tell us what's on your mind. Be as detailed or ranty as you want."
              className="form-textarea"
              required
            />
          </div>

          <Button
            type="submit"
            variant="primary"
            fullWidth
            loading={isSubmitting}
            disabled={isSubmitting}
            className="submit-button"
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </Button>

          {formStatus === 'success' && (
            <div className="form-message success">
              ✅ Message sent! We'll get back to you soon. (Unless it was just a complaint. Then
              we'll cry quietly and move on.)
            </div>
          )}

          {formStatus === 'error' && (
            <div className="form-message error">
              ❌ Oops! Something went wrong. Please try again.
            </div>
          )}
        </form>

        <div className="contact-footer">
          <p>
            <strong>Response Time:</strong> Usually within 24-48 hours. Unless we're playing the
            game. Then maybe 72 hours.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
